import { render, staticRenderFns } from "./anchorRegister.vue?vue&type=template&id=50f19e64&scoped=true&"
import script from "./anchorRegister.vue?vue&type=script&lang=js&"
export * from "./anchorRegister.vue?vue&type=script&lang=js&"
import style0 from "./anchorRegister.vue?vue&type=style&index=0&id=50f19e64&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f19e64",
  null
  
)

export default component.exports